import React, { Component } from 'react';
import "../../../../../style/registerPage.css"
import BuildingContext from "../../../../../contexts/Building";
import {DatePicker} from "react-persian-datepicker";
import SimpleTextInput from "../../../../CustomInputs/SimpleTextInput";
import DateInput from "../../../../CustomInputs/DateInput";
class CInformationFurtherPage extends Component {
    static contextType = BuildingContext;

    state = {}
    render() {
        return (
            <>
                <div className="register-step-box" style={{marginBottom: "200px"}}>
                    <h2>مشخصات تکمیلی</h2>
                    <div className='d-flex flex-wrap justify-content-start'>
                        <div className="input-group-register col-md-4 col-12">
                            <SimpleTextInput
                                condition1={this.context.constantInformationFurtherValidation.phoneNumber_requiredReg}
                                condition2={this.context.constantInformationFurtherValidation.phoneNumber_telephoneReg}
                                value={this.context.constantInformationFurther.phoneNumber}
                                fieldNameString={'constantInformationFurther'}
                                valueOfInputString={'phoneNumber'}
                                digitsOnly={true}
                                maxLength={11}
                                required={true}
                                label={'شماره همراه اقامتگر'}
                            />
                        </div>
                        <div className="input-group-register col-md-4 col-12">
                            <SimpleTextInput
                                condition1={this.context.constantInformationFurtherValidation.telephoneNumber_requiredReg}
                                condition3={this.context.constantInformationFurtherValidation.telephoneNumber_homeTelephoneReg}
                                value={this.context.constantInformationFurther.telephoneNumber}
                                fieldNameString={'constantInformationFurther'}
                                valueOfInputString={'telephoneNumber'}
                                digitsOnly={true}
                                maxLength={11}
                                required={false}
                                label={'شماره تلفن منزل'}
                            />
                        </div>
                        <div className="input-group-register col-md-4 col-12">
                            <DateInput condition1={this.context.constantInformationFurtherValidation.startDate_requiredReg}
                                       value={this.context.valueOfDates.constantResident.startDate}
                                       valueFieldString={'constantResident'}
                                       fieldNameString={'constantInformationFurther'}
                                       valueOfInputString={'startDate'}
                                       timeInclude={false}
                            />
                            <label className="placeholder" style={{
                                top: '-5px',
                                backgroundColor: '#fff',
                                color: '#84888a',
                                margin: '0 .3rem',
                                opacity: '1',
                            }}>تاریخ شروع پذیرش</label>
                        </div>
                        <div className="input-group-register col-md-4 col-12">
                            <DateInput condition1={this.context.constantInformationFurtherValidation.endDate_requiredReg}
                                       value={this.context.valueOfDates.constantResident.endDate}
                                       valueFieldString={'constantResident'}
                                       fieldNameString={'constantInformationFurther'}
                                       valueOfInputString={'endDate'}
                                       timeInclude={false}
                            />
                            <label className="placeholder" style={{
                                top: '-5px',
                                backgroundColor: '#fff',
                                color: '#84888a',
                                margin: '0 .3rem',
                                opacity: '1',
                            }}>تاریخ اتمام پذیرش</label>
                        </div>
                        <div className="input-group-register col-md-4 col-12 date-container">
                            <DateInput
                                condition1={this.context.constantInformationFurtherValidation.depositReturnDate_requiredReg}
                                value={this.context.valueOfDates.constantResident.depositReturnDate}
                                valueFieldString={'constantResident'}
                                fieldNameString={'constantInformationFurther'}
                                valueOfInputString={'depositReturnDate'}
                                timeInclude={false}
                            />
                            <label className="placeholder" style={{
                                top: '-5px',
                                backgroundColor: '#fff',
                                color: '#84888a',
                                margin: '0 .3rem',
                                opacity: '1',
                            }}>تاریخ عودت ودیعه (۴۵ روز بعد از خروج)</label>
                        </div>
                        <div className="input-group-register col-12">
                            <SimpleTextInput
                                condition1={this.context.constantInformationFurtherValidation.address_requiredReg}
                                value={this.context.constantInformationFurther.address}
                                fieldNameString={'constantInformationFurther'}
                                valueOfInputString={'address'}
                                required={false}
                                label={'آدرس محل سکونت'}
                            />
                        </div>
                        <div className="input-group-register col-md-4 col-12">
                            <SimpleTextInput
                                value={this.context.constantInformationFurther.parentAddress}
                                fieldNameString={'constantInformationFurther'}
                                valueOfInputString={'parentAddress'}
                                label={'دهستان'}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export  default CInformationFurtherPage ;